module.exports = __webpack_public_path__ + "static/media/vehicle_doesnt_start.5e279c43.svg";